/* CELIMAX · The Vita A Retinal Shot — interacciones de marca */
(function () {
  'use strict';
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---------- aparicion en pantalla ---------- */
  function observe(sel, cb, once) {
    var els = document.querySelectorAll(sel);
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { [].forEach.call(els, function (e) { cb(e); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        cb(en.target);
        if (once !== false) io.unobserve(en.target);
      });
    }, { threshold: 0.25, rootMargin: '0px 0px -8% 0px' });
    [].forEach.call(els, function (e) { io.observe(e); });
  }

  /* ---------- 1. inclinacion 3D con el raton ---------- */
  function tilt() {
    if (RM) return;
    [].forEach.call(document.querySelectorAll('[data-vt-tilt]'), function (el) {
      var max = parseFloat(el.getAttribute('data-vt-tilt')) || 8;
      var raf = null, tx = 0, ty = 0;
      function apply() {
        raf = null;
        el.style.transform = 'perspective(1100px) rotateX(' + ty + 'deg) rotateY(' + tx + 'deg)';
      }
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width;
        var py = (e.clientY - r.top) / r.height;
        tx = (px - 0.5) * 2 * max;
        ty = -(py - 0.5) * 2 * max;
        el.style.setProperty('--gx', (px * 100).toFixed(1) + '%');
        el.style.setProperty('--gy', (py * 100).toFixed(1) + '%');
        el.classList.add('is-live');
        if (!raf) raf = requestAnimationFrame(apply);
      });
      el.addEventListener('pointerleave', function () {
        el.classList.remove('is-live');
        el.style.transform = '';
      });
    });
  }

  /* ---------- 2. anillo de texto en 3D alrededor del bote ---------- */
  function rings() {
    [].forEach.call(document.querySelectorAll('[data-vt-ring]'), function (host) {
      var txt = (host.getAttribute('data-vt-ring') || '').trim();
      if (!txt) return;
      var radius = parseFloat(host.getAttribute('data-vt-radius')) || 160;
      var inner = host.querySelector('.vt-ring-in');
      if (!inner) return;
      var chars = txt.split('');
      var step = 360 / chars.length;
      chars.forEach(function (c, i) {
        var s = document.createElement('i');
        s.textContent = c === ' ' ? ' ' : c;
        s.style.transform = 'rotateZ(' + (i * step) + 'deg) translateY(-' + radius + 'px) rotateX(-74deg)';
        inner.appendChild(s);
      });
    });
  }

  /* ---------- 3. micropartículas A-Shot ---------- */
  function ashot() {
    [].forEach.call(document.querySelectorAll('[data-vt-ashot]'), function (box) {
      var cv = box.querySelector('canvas');
      if (!cv || !cv.getContext) return;
      var ctx = cv.getContext('2d');
      var color = getComputedStyle(box).getPropertyValue('--cc-accent').trim() || '#DADB67';
      var W = 0, H = 0, dpr = Math.min(window.devicePixelRatio || 1, 2);
      var parts = [], running = false, poreX = 0.5, poreY = 0.62;

      function size() {
        var r = cv.getBoundingClientRect();
        W = r.width; H = r.height;
        cv.width = Math.max(1, W * dpr); cv.height = Math.max(1, H * dpr);
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      }
      function spawn() {
        return {
          x: Math.random() * W,
          y: -Math.random() * H * 0.5,
          r: 0.7 + Math.random() * 1.7,
          v: 0.35 + Math.random() * 0.9,
          a: 0.25 + Math.random() * 0.6,
          d: (Math.random() - 0.5) * 0.25
        };
      }
      function draw() {
        if (!running) return;
        ctx.clearRect(0, 0, W, H);
        var tx = poreX * W, ty = poreY * H;
        for (var i = 0; i < parts.length; i++) {
          var p = parts[i];
          p.y += p.v;
          p.x += p.d;
          // por debajo de la superficie, las particulas convergen hacia el poro
          if (p.y > H * 0.46) {
            p.x += (tx - p.x) * 0.035;
            p.a *= 0.985;
          }
          if (p.y > ty + 10 || p.a < 0.04) { parts[i] = spawn(); continue; }
          ctx.beginPath();
          ctx.globalAlpha = p.a;
          ctx.fillStyle = color;
          ctx.arc(p.x, p.y, p.r, 0, 6.2832);
          ctx.fill();
        }
        ctx.globalAlpha = 1;
        requestAnimationFrame(draw);
      }
      size();
      var n = RM ? 0 : Math.round(Math.min(190, Math.max(60, W * 0.42)));
      for (var i = 0; i < n; i++) parts.push(spawn());
      window.addEventListener('resize', size);
      if (!('IntersectionObserver' in window)) { running = true; draw(); return; }
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting && !running) { running = true; draw(); }
          else if (!e.isIntersecting) { running = false; }
        });
      }, { threshold: 0.08 }).observe(box);
    });
  }

  /* ---------- 4. contadores ---------- */
  function counters() {
    observe('[data-vt-count]', function (el) {
      var to = parseFloat(el.getAttribute('data-vt-count'));
      var dec = parseInt(el.getAttribute('data-vt-dec') || '0', 10);
      var suf = el.getAttribute('data-vt-suffix') || '';
      var pre = el.getAttribute('data-vt-prefix') || '';
      if (isNaN(to)) return;
      if (RM) { el.textContent = pre + fmt(to, dec) + suf; return; }
      var t0 = null, dur = 1700;
      function fmt(v, d) {
        return v.toFixed(d).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, d ? '' : '.');
      }
      function tick(ts) {
        if (!t0) t0 = ts;
        var k = Math.min(1, (ts - t0) / dur);
        var e = 1 - Math.pow(1 - k, 3);
        el.textContent = pre + fmt(to * e, dec) + suf;
        if (k < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    });
  }
  function fmt(v, d) {
    return v.toFixed(d).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, d ? '' : '.');
  }

  /* ---------- 5. aros de progreso ---------- */
  function arcs() {
    observe('[data-vt-arc]', function (el) {
      var pct = parseFloat(el.getAttribute('data-vt-arc')) || 0;
      var arc = el.querySelector('.vt-arc');
      if (arc) arc.style.strokeDashoffset = String(440 - (440 * Math.min(100, pct)) / 100);
    });
  }

  /* ---------- 6. clase al entrar (linea del ritual) ---------- */
  function enters() { observe('[data-vt-in]', function (el) { el.classList.add('cc-in'); }); }

  /* ---------- 7. selector de pack ---------- */
  function packs() {
    [].forEach.call(document.querySelectorAll('[data-vt-packs]'), function (root) {
      var form = root.closest('form') || document;
      var hidden = root.querySelector('[data-vt-variant]');
      var price = form.querySelector('[data-vt-price]');
      var cta = form.querySelector('[data-vt-cta]');
      function sync(input) {
        if (hidden) hidden.value = input.value;
        if (price && input.getAttribute('data-price')) price.textContent = input.getAttribute('data-price');
        var out = input.getAttribute('data-available') === 'false';
        if (cta) {
          cta.disabled = out;
          var lbl = out ? cta.getAttribute('data-out') : cta.getAttribute('data-in');
          if (lbl) { var sp = cta.querySelector('[data-vt-cta-txt]'); (sp || cta).textContent = lbl; }
        }
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', input.value);
          window.history.replaceState({}, '', u.toString());
        } catch (e) {}
      }
      [].forEach.call(root.querySelectorAll('input[type="radio"]'), function (i) {
        i.addEventListener('change', function () { if (i.checked) sync(i); });
        if (i.checked) sync(i);
      });
    });
  }

  /* ---------- 8. galeria ---------- */
  function gallery() {
    [].forEach.call(document.querySelectorAll('[data-vt-gal]'), function (g) {
      var main = g.querySelector('[data-vt-main]');
      if (!main) return;
      [].forEach.call(g.querySelectorAll('[data-vt-thumb]'), function (b) {
        b.addEventListener('click', function () {
          var src = b.getAttribute('data-src');
          if (!src) return;
          main.style.opacity = '0';
          setTimeout(function () { main.src = src; main.style.opacity = '1'; }, 130);
          [].forEach.call(g.querySelectorAll('[data-vt-thumb]'), function (o) { o.setAttribute('aria-current', 'false'); });
          b.setAttribute('aria-current', 'true');
        });
      });
    });
  }

  /* ---------- 9. chispas del cierre ---------- */
  function sparks() {
    if (RM) return;
    [].forEach.call(document.querySelectorAll('[data-vt-sparks]'), function (host) {
      var n = parseInt(host.getAttribute('data-vt-sparks'), 10) || 14;
      for (var i = 0; i < n; i++) {
        var s = document.createElement('span');
        s.className = 'vt-spark';
        s.style.left = (Math.random() * 100).toFixed(2) + '%';
        s.style.bottom = (-10 + Math.random() * 30).toFixed(1) + '%';
        s.style.animationDuration = (6 + Math.random() * 7).toFixed(1) + 's';
        s.style.animationDelay = (-Math.random() * 10).toFixed(1) + 's';
        s.style.opacity = (0.25 + Math.random() * 0.5).toFixed(2);
        s.style.transform = 'scale(' + (0.5 + Math.random()).toFixed(2) + ')';
        host.appendChild(s);
      }
    });
  }

  /* ---------- 10. parallax suave del hero ---------- */
  function parallax() {
    if (RM) return;
    var els = document.querySelectorAll('[data-vt-par]');
    if (!els.length) return;
    var raf = null;
    function run() {
      raf = null;
      var vh = window.innerHeight || 800;
      [].forEach.call(els, function (el) {
        var k = parseFloat(el.getAttribute('data-vt-par')) || 0.08;
        var r = el.getBoundingClientRect();
        var off = (r.top + r.height / 2 - vh / 2) * -k;
        el.style.transform = 'translate3d(0,' + off.toFixed(1) + 'px,0)';
      });
    }
    window.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(run); }, { passive: true });
    run();
  }

  /* ---------- 11. ir a la caja de reseñas (Ali Reviews) ---------- */
  // La app no pinta la caja hasta que está cerca de la pantalla. Si se baja con
  // scroll suave mientras aparece, Safari deja la zona en blanco hasta que se toca
  // la pantalla: por eso se salta directo, se sujeta la caja arriba mientras crece
  // y se fuerza un repintado.
  function reviews() {
    if (window.__vtReviews) return;
    window.__vtReviews = true;
    var box = document.querySelector('.ali-widget-app-ext');
    var links = document.querySelectorAll('[data-vt-reviews-go]');
    if (!box) return;
    var root = document.documentElement;

    function jump() {
      var prev = root.style.scrollBehavior;
      root.style.scrollBehavior = 'auto';
      box.scrollIntoView({ block: 'start' });
      window.scrollBy(0, 1);
      window.scrollBy(0, -1);
      root.style.scrollBehavior = prev;
      window.dispatchEvent(new Event('scroll'));
    }

    function pin(ms) {
      var on = true;
      var stop = function () { on = false; };
      ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(function (ev) {
        window.addEventListener(ev, stop, { once: true, passive: true });
      });
      var go = function () { if (on) jump(); };
      if ('ResizeObserver' in window) {
        var ro = new ResizeObserver(go);
        ro.observe(document.body);
        setTimeout(function () { ro.disconnect(); stop(); }, ms);
      } else {
        setTimeout(go, 400);
        setTimeout(go, 1200);
        setTimeout(stop, ms);
      }
      go();
    }

    [].forEach.call(links, function (a) {
      a.hidden = false;
      a.setAttribute('href', '#resenas');
      a.addEventListener('click', function (e) {
        e.preventDefault();
        pin(2500);
      });
    });

    if (location.hash === '#resenas') pin(3000);
  }

  ready(function () {
    document.documentElement.classList.add('vt-js');
    tilt(); rings(); ashot(); counters(); arcs(); enters(); packs(); gallery(); sparks(); parallax(); reviews();
  });
})();
